import React from "react";
import SFTypography from "../typography";
import { SFButton } from "../buttons";
import { SFStack } from "../grid";
import SFProgress from "../progress";
import { Box } from "@mui/material";
import { SFLoadingPage } from "../loading";

const SFHeroSlide = ({
  title,
  description,
  image,
  thumbnail,
  stats = [],
  actions = [],
  loading = false,
}) => (
  <Box
    sx={{
      height: 335, //461,
      backgroundImage: `url(${image})`,
      backgroundPosition: "center" /* Center the image */,
      backgroundRepeat: "no-repeat" /* Do not repeat the image */,
      backgroundSize: "cover",
      borderRadius: "6px",
      boxShadow: "0px 0px 15px 0px rgba(0,0,0,0.75)",
    }}
  >
    {loading ? (
      <SFStack
        justifyContent="center"
        alignItems={"center"}
        sx={{
          height: "100%",
          width: "100%",
        }}
      >
        <SFLoadingPage size="large" />
      </SFStack>
    ) : (
      <SFStack
        justifyContent="center"
        direction="column"
        spacing={2}
        sx={{
          paddingX: 9,
          paddingY: 2,
          height: "100%",
          background:
            "linear-gradient(90deg, rgba(0, 0, 0, 0.5) 24.48%, rgba(0, 0, 0, 0.06) 72.92%)",
        }}
      >
        {thumbnail && thumbnail}
        <SFTypography variant="heroTitle">{title}</SFTypography>
        <SFTypography
          variant="heroDescription"
          maxLines={3}
          sx={{
            maxWidth: "90%",
          }}
        >
          {description}
        </SFTypography>
        <SFStack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-end"
          spacing={6}
        >
          {stats.map((item, index) =>
            item.type === "progress" ? (
              <SFProgress
                key={index}
                title={item.title}
                titleVariant={item.titleVariant}
                value={item.value}
                maxWidth={item.maxWidth}
                narrow
              />
            ) : (
              <SFTypography
                key={`${item.label}-${index}`}
                variant="detailsPageHeading"
                component="span"
              >
                {item.total}
                <SFTypography
                  variant="heroDescription"
                  component="span"
                  sx={{ ml: 1 }}
                >
                  {item.label}
                </SFTypography>
              </SFTypography>
            )
          )}
        </SFStack>
        <SFStack
          direction="row"
          spacing={2.5}
          sx={{
            marginTop: stats.length > 0 ? "32px !important" : "10px !important",
          }}
        >
          {actions.map((action, index) => (
            <SFButton
              key={`${action.label}-${index}`}
              variant={action.variant ?? "transparent"}
              onClick={action.onClick}
            >
              <SFStack direction="row" spacing={1} alignItems="center">
                {action.icon && action.icon}
                <SFTypography>{action.label}</SFTypography>
              </SFStack>
            </SFButton>
          ))}
        </SFStack>
      </SFStack>
    )}
  </Box>
);

export default SFHeroSlide;
